export default "__VITE_ASSET__CstasndC__"